// POPU brand icon — matches the user's reference logo exactly:
// Black rounded square with a slanted lowercase "p" + pink dot acting as the period
export default function PopuIcon({ size = 48, className = "" }) {
  const radius = Math.round(size * 0.2);
  const fontSize = size * 0.78;
  return (
    <div
      className={`shrink-0 relative inline-flex items-center justify-center text-white select-none ${className}`}
      style={{
        width: size,
        height: size,
        background: "#0A0A0A",
        borderRadius: radius,
      }}
      aria-label="POPU"
    >
      <span
        className="popu-logo"
        style={{
          fontSize: `${fontSize}px`,
          lineHeight: 1,
          color: "#FFF",
          fontStyle: "italic",
          transform: "skew(-8deg)",
          textTransform: "lowercase",
          marginRight: size * 0.04,
        }}
      >
        p
      </span>
      <span
        className="absolute rounded-full"
        style={{
          background: "var(--accent)",
          width: Math.max(7, size * 0.16),
          height: Math.max(7, size * 0.16),
          right: size * 0.12,
          bottom: size * 0.16,
        }}
      />
    </div>
  );
}
